@if (!loading() && isBrowser) {
  <router-outlet></router-outlet>
  <div class="header-container">
    <app-view-gallery-header
      class="dark"
      [gallery]="gallery()"
      [galleryPermissions]="galleryPermissions()"
      [theme]="theme()"
      [mode]="'advanced'"
    ></app-view-gallery-header>
  </div>
  <app-advanced-mode
    [gallery]="gallery()"
    [assets]="assets()"
    [sections]="sections()"
    [clientMode]="true"
    [blockShortcuts]="onAssetPage()"
  ></app-advanced-mode>
  @if (gallery()?.approval_limits) {
    <app-approval-limit-info [gallery]="gallery()"></app-approval-limit-info>
  }
} @else {
  <div class="loading">
    <app-loading-indicator></app-loading-indicator>
  </div>
}
